// !因为背调的业务原因，且有些信息都是后端放在候选人级别的，刷库的难度挺大。
// !因此将一些展示的信息做一个替换，替换规则如下所示。
export function replaceBgCheckString(input: string): string {
  let result = input;
  if (!result) return result;
  result = result.replace(/背调/g, "综合调查评估");
  result = result.replace(/金融风险/g, "综合B类评估");
  result = result.replace(/社会安全风险/g, "综合A类评估");
  result = result.replace(/社会安全/g, "综合A类评估");
  result = result.replace(/金融低风险/g, "综合B类低高险");
  result = result.replace(/金融中风险/g, "综合B类中风险");
  result = result.replace(/金融高风险/g, "综合B类高风险");
  return result;
}
